import React, { useCallback, useEffect, useState } from "react";
import { Box, Text, Flex } from "atoms";

import MemoTickIcon from "assets/icons/Tick";

export const Checkbox = ({
  children,
  checked,
  size = 18,
  disabled,
  activeColor = "secondary.700",
  classes,
  label,
  height,
  ...props
}) => {
  // const [checked, setChecked] = useState(value);

  // useEffect(() => {
  //   setChecked(value);
  // }, [value]);

  // const onToggle = useCallback(() => {
  //   setChecked((prev) => !prev);
  // }, []);

  // const onChangeHandler = useCallback(() => {
  //   if (typeof onChange === "function") {
  //     onChange(!checked);
  //   }
  // }, [onChange, checked]);

  return (
    <Flex
      as="label"
      flexWrap="nowrap"
      aI="center"
      className={classes}
      cursor={disabled ? "not-allowed" : "pointer"}
      {...props}
    >
      <Flex
        mr="1.6rem"
        height={height}
        minWidth={size}
        minHeight={size}
        border="2px solid"
        bg={checked ? activeColor : undefined}
        borderColor={checked ? activeColor : "neutral.300"}
        aI="center"
        jC="center"
      >
        <input
          hidden
          type="checkbox"
          checked={checked}
          disabled={disabled}
          {...props}
        />
        <Box color={checked ? "white" : "transparent"}>
          <MemoTickIcon />
        </Box>
      </Flex>
      <Box style={{ userSelect: "none" }}>
        <Text
          fontFamily="NeometricRegular"
          fontSize="1.6rem"
          color="neutral.700"
        >
          {label}
        </Text>
      </Box>
    </Flex>
  );
};
